import { render } from "./Track.vue?vue&type=template&id=8825250e&scoped=true"
import script from "./Track.vue?vue&type=script&lang=js"
export * from "./Track.vue?vue&type=script&lang=js"

import "./Track.vue?vue&type=style&index=0&id=8825250e&scoped=true&lang=css"

import exportComponent from "/Users/user/Development/spin-demo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8825250e"]])

export default __exports__